window._evCmdInterval = setInterval(()=>{
	_evCmd = window._evCmd || [];

	if (!_evCmd || !_evCmd.length || _evCmd.length<1) {
		return false;
	}
	let fn = _evCmd.shift();
	if ( typeof fn=='function' ) {
		fn();
	}
}, 250);

var app = window.app || {};
window.addEventListener('DOMContentLoaded', ()=>{
    console.log('main DOMContentLoaded');

    if ( window.app.imgCanUseWebP && window.app.imgCanUseWebP() ) {
		document.body.classList.add('webp');
	}
});

app.imgCanUseWebP = function() {
    var el = document.createElement('canvas');
    if (!!(el.getContext && el.getContext('2d')) ) {
      return el.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    return false;
};
app.deskToggleHeadSearch = function() {
	return ((a)=>{
		if ( !a || !a.querySelector ) {
			return false;
		}
		a.querySelector('.toggle-width').style.width = '170px';
		let b = a.querySelector('button');
		if ( b.type!=='submit' ) {
			a.querySelector('input[type="search"]').focus();
			setTimeout( ()=>{b.type="submit";}, 300 );
			return false;
		}

		return true;

	})( document.getElementById('HeaderDesktopSearch') );
};

window.addEventListener('resize',()=>{
	console.log(window.innerWidth, window.innerHeight);
});

(($)=>{
	if (!$ || typeof $!=='function') {
		return false;
	}
	$(document).ready(function(){
		$('#MovilMainMenu').data('height', $('#MovilMainMenu .mycontent').outerHeight().toString() + 'px' );

		$('.btn-toggle-movilmenu').on('click', function(){
			if ( $('#MovilMainMenu').css('height')!=='0px' ) {
				$('#MovilMainMenu').css('height', '0px');
			}
			else {
				$('#MovilMainMenu').css('height', $('#MovilMainMenu').data('height') );
			}
		});

		if ( document.getElementById('mapa-rep-mex') ) {
			$('#sucLista [id^="suc"]').hide();
			$('#sucCDMX').show();
			$('#mapa-rep-mex path[id]').on('click',function(){
				$('#sucLista [id^="suc"]').hide();
				$('#suc'+this.id).show();
			});
		}
	});
})(jQuery);